export const googleReviews = [
  {
    name: "bhavna gupta",
    date: "2026-08-21T19:43:48",
    text: "Recently enrolled my in this coding class. she has had a wonderful experience. The sessions are engaging, interactive, and easy for children to understand.Highly recommended for children who want to learn coding in a fun and enjoyable way.",
    rating: 5,
    avatarInitial: "B",
    avatarBg: "#ea580c"
  },
  {
    name: "Teena Soni",
    date: "2026-08-19T14:43:48",
    text: "Very good experience",
    rating: 5,
    avatarInitial: "T",
    avatarBg: "#9333ea"
  },
  {
    name: "Shivani aggarwal",
    date: "2026-07-14",
    text: "VERY Good Learning Tools for kids",
    rating: 5,
    avatarInitial: "S",
    avatarBg: "#8b5cf6"
  },
  {
    name: "Sanjay Aggarwal",
    date: "2026-07-14",
    text: "Very good learning program for AI,Coding 3d printing and Robotics.",
    rating: 5,
    avatarInitial: "S",
    avatarBg: "#3b82f6"
  },
  {
    name: "Sonia Sandhu",
    date: "2026-07-14",
    text: "Excellent",
    rating: 5,
    avatarInitial: "S",
    avatarBg: "#10b981"
  }
];
